<template>
<div class="chapter">
<div class="inner_page">
<div class="MAIN_PAGE" id="d5e2576">
<p class="ct" id="ta"><a href="#/contents#pa"><b>PART ONE</b></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// partone.vue?630d4e34